"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboboxRadix = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Popover = __importStar(require("@radix-ui/react-popover"));
const cmdk_1 = require("cmdk");
const react_1 = require("react");
const constants_1 = require("../../constants");
const translate_1 = require("../../translate");
const Icon_1 = require("../Icon");
const FilterInput_1 = require("../Menu/PopoverCombobox/FilterInput");
const Options_1 = require("../Menu/PopoverCombobox/Options");
const styles_1 = require("../Menu/styles");
const Panel = (0, styled_1.default)(cmdk_1.Command)(styles_1.panelStyles);
const PopoverContent = (0, styled_1.default)(Popover.Content) `
  width: var(--radix-popover-trigger-width);
  z-index: ${constants_1.theme.zIndex.popover};
`;
const Trigger = styled_1.default.button(({ empty }) => ({
    background: constants_1.Color.LIGHT_GREY,
    color: empty ? constants_1.Color.DARK_GREY : 'inherit',
    border: constants_1.theme.border.style.thinMedium,
    borderRadius: constants_1.theme.border.radius.normal,
    boxSizing: 'border-box',
    cursor: 'pointer',
    fontFamily: 'inherit',
    lineHeight: `${constants_1.theme.elements.icon.size.sm}px`,
    padding: `${constants_1.theme.spacing['2']}px ${constants_1.theme.spacing['2.5']}px`,
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: constants_1.theme.spacing['3'],
    width: '100%',
    '&:disabled': {
        color: constants_1.Color.DARK_MEDIUM_GREY,
        cursor: 'not-allowed',
    },
}));
const ComboboxRadix = ({ options, value, placeholder, onChange, clearable, showFilter, disabled, }) => {
    const t = (0, translate_1.useTranslations)();
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const selected = (0, react_1.useMemo)(() => {
        return options.find((option) => option.value === value);
    }, [value]);
    const groups = (0, react_1.useMemo)(() => {
        return [
            {
                items: options,
            },
        ];
    }, [options]);
    return ((0, jsx_runtime_1.jsxs)(Popover.Root, { open: isOpen, onOpenChange: setIsOpen, children: [(0, jsx_runtime_1.jsx)(Popover.Trigger, { asChild: true, children: (0, jsx_runtime_1.jsxs)(Trigger, { empty: !selected, disabled: disabled, children: [selected
                            ? selected.label
                            : (placeholder ?? `${t.form.select_a_value()}...`), (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "ChevronDownIcon", size: "sm" })] }) }), (0, jsx_runtime_1.jsx)(Popover.Portal, { children: (0, jsx_runtime_1.jsx)(PopoverContent, { sideOffset: 4, children: (0, jsx_runtime_1.jsxs)(Panel, { children: [showFilter && ((0, jsx_runtime_1.jsx)(FilterInput_1.FilterInput, { autoFocus: true, placeholder: t.ui.filter_ellipsis() })), (0, jsx_runtime_1.jsx)(Options_1.PopoverComboboxOptions, { groups: groups, onSelect: (value) => {
                                    setIsOpen(false);
                                    if (clearable && value === selected?.value) {
                                        onChange(undefined);
                                    }
                                    else {
                                        onChange(value);
                                    }
                                }, type: "singleSelect", value: value })] }) }) })] }));
};
exports.ComboboxRadix = ComboboxRadix;
